var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" Danh sách người thân ")]),_c('v-card-text',[_c('v-data-table',{attrs:{"items":_vm.families,"headers":_vm.familyHeaders}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }